import { render, staticRenderFns } from "./commentField.vue?vue&type=template&id=7b77efd1&scoped=true"
import script from "./commentField.vue?vue&type=script&lang=js"
export * from "./commentField.vue?vue&type=script&lang=js"
import style0 from "./commentField.vue?vue&type=style&index=0&id=7b77efd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b77efd1",
  null
  
)

export default component.exports